/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
define(["require", "exports", "azure-devops-ui/Ago", "azure-devops-ui/Card", "azure-devops-ui/Core/Observable", "azure-devops-ui/Core/Util/String", "azure-devops-ui/Header", "azure-devops-ui/Link", "azure-devops-ui/Status", "azure-devops-ui/Table", "azure-devops-ui/TooltipEx", "azure-devops-ui/Utilities/Provider", "azure-devops-ui/Util", "react", "../../Contracts/KubeServiceBase", "../../Resources", "../Common/KubeCardWithTable", "../Constants", "../FluxCommon/ActionsCreatorManager", "../FluxCommon/StoreManager", "../ImageDetails/ImageDetailsActionsCreator", "../ImageDetails/ImageDetailsStore", "../KubeFactory", "../Pods/PodsStore", "../Selection/SelectionActionCreator", "../Utils", "./WorkloadsActionsCreator", "./WorkloadsStore"], function (require, exports, Ago_1, Card_1, Observable_1, String_1, Header_1, Link_1, Status_1, Table_1, TooltipEx_1, Provider_1, Util_1, React, KubeServiceBase_1, Resources, KubeCardWithTable_1, Constants_1, ActionsCreatorManager_1, StoreManager_1, ImageDetailsActionsCreator_1, ImageDetailsStore_1, KubeFactory_1, PodsStore_1, SelectionActionCreator_1, Utils_1, WorkloadsActionsCreator_1, WorkloadsStore_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var setNameKey = "otherwrkld-name-key";
    var imageKey = "otherwrkld-image-key";
    var podsKey = "otherwrkld-pods-key";
    var ageKey = "otherwrkld-age-key";
    var OtherWorkloads = /** @class */ (function (_super) {
        __extends(OtherWorkloads, _super);
        function OtherWorkloads(props) {
            var _this = _super.call(this, props, {}) || this;
            _this._onStatefulSetsFetched = function () {
                var storeState = _this._store.getState();
                _this.setState({
                    statefulSets: storeState.statefulSetList && storeState.statefulSetList.items || []
                }, function () { return _this._onMetadataFetch("statefulsets"); });
            };
            _this._onDaemonSetsFetched = function () {
                var storeState = _this._store.getState();
                _this.setState({
                    daemonSets: storeState.daemonSetList && storeState.daemonSetList.items || []
                }, function () { return _this._onMetadataFetch("daemon"); });
            };
            _this._onReplicaSetsFetched = function () {
                var storeState = _this._store.getState();
                var allReplicaSets = storeState.replicaSetList && storeState.replicaSetList.items || [];
                var standAloneReplicaSets = allReplicaSets.filter(function (set) { return set.metadata.ownerReferences.length === 0; });
                _this.setState({
                    replicaSets: standAloneReplicaSets
                }, function () { return _this._onMetadataFetch("replicasets"); });
            };
            _this._onOrphanPodsFetched = function () {
                var storeState = _this._store.getState();
                var orphanPods = storeState.orphanPodsList || [];
                _this.setState({
                    orphanPods: orphanPods
                }, function () { return _this._onMetadataFetch("orphanpods"); });
            };
            _this._setHasImageDetails = function () {
                _this.setState({});
            };
            _this._onMetadataFetch = function (key) {
                _this._metadataInitialized[key] = true;
                var metaInitialized = true;
                Object.keys(_this._metadataInitialized).forEach(function (key) { return metaInitialized = metaInitialized && _this._metadataInitialized[key]; });
                if (metaInitialized) {
                    _this.props.markTTICallback && _this.props.markTTICallback({ "component": "OtherWorkloads" });
                }
            };
            _this._showWorkloadDetails = function (event, tableRow, selectedItem) {
                if (selectedItem) {
                    var payload = {
                        item: selectedItem.payload,
                        itemUID: selectedItem.uid,
                        showSelectedItem: true,
                        selectedItemType: selectedItem.kind
                    };
                    _this._selectionActionCreator.selectItem(payload);
                }
            };
            _this._getColumns = function () {
                var columns = [];
                columns.push({
                    id: setNameKey,
                    name: Resources.NameText,
                    width: new Observable_1.ObservableValue(348),
                    renderCell: OtherWorkloads._renderSetNameCell
                });
                columns.push({
                    id: imageKey,
                    name: Resources.ImageText,
                    width: -72,
                    renderCell: _this._renderImageCell
                });
                columns.push({
                    id: podsKey,
                    name: Resources.PodsText,
                    width: new Observable_1.ObservableValue(140),
                    renderCell: _this._renderPodsCountCell
                });
                columns.push({
                    id: ageKey,
                    name: Resources.AgeText,
                    width: -28,
                    renderCell: OtherWorkloads._renderAgeCell
                });
                return columns;
            };
            _this._renderImageCell = function (rowIndex, columnIndex, tableColumn, workload) {
                var imageId = workload.imageId;
                var imageText = workload.imageDisplayText || "";
                var imageDetailsUnavailableTooltipText = "";
                var hasImageDetails = _this._imageDetailsStore.hasImageDetails(imageId);
                // If hasImageDetails is undefined, then image details promise has not resolved, so do not set imageDetailsUnavailable tooltip
                if (hasImageDetails === false) {
                    imageDetailsUnavailableTooltipText = String_1.localeFormat("{0} | {1}", workload.imageTooltip || imageText, Resources.ImageDetailsUnavailableText);
                }
                var itemToRender = hasImageDetails ?
                    React.createElement(TooltipEx_1.Tooltip, { overflowOnly: true },
                        React.createElement(Link_1.Link, { className: Util_1.css("body-m text-ellipsis bolt-table-link", _this._imageLinkClassName), excludeTabStop: true, onClick: function (e) {
                                e.preventDefault();
                                _this._onImageClick(imageId);
                            } }, imageText))
                    : KubeCardWithTable_1.defaultColumnRenderer(imageText, "body-m", imageDetailsUnavailableTooltipText);
                return KubeCardWithTable_1.renderTableCell(rowIndex, columnIndex, tableColumn, itemToRender, undefined, "bolt-table-cell-content-with-link");
            };
            _this._renderPodsCountCell = function (rowIndex, columnIndex, tableColumn, workload) {
                var _a = Utils_1.Utils.getPodsStatusProps(workload.currentPodCount, workload.desiredPodCount), statusProps = _a.statusProps, pods = _a.pods, podsTooltip = _a.podsTooltip;
                var payload = workload.payload;
                var podslist = StoreManager_1.StoreManager.GetStore(PodsStore_1.PodsStore).getState().podsList;
                var relevantPods = (podslist && podslist.items && podslist.items.filter(function (p) { return (payload && Utils_1.Utils.isOwnerMatched(p.metadata, payload.metadata.uid)) || false; }));
                var type = Utils_1.Utils.getKindFromItemTypeKey(workload.kind);
                var _onPodsClicked = (relevantPods && payload) ? (function () { return KubeCardWithTable_1.onPodsColumnClicked(relevantPods, payload, type, _this._selectionActionCreator); }) : undefined;
                return KubeCardWithTable_1.renderPodsStatusTableCell(rowIndex, columnIndex, tableColumn, pods, statusProps, podsTooltip, _onPodsClicked, _this._podsLinkClassName);
            };
            _this._onImageClick = function (imageId, itemUid) {
                if (itemUid === void 0) { itemUid = ""; }
                var showImageDetails = function (imageDetails) {
                    var payload = {
                        item: imageDetails,
                        itemUID: itemUid,
                        showSelectedItem: true,
                        selectedItemType: "image-details" /* ImageDetailsKey */
                    };
                    _this._selectionActionCreator.selectItem(payload);
                };
                ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(ImageDetailsActionsCreator_1.ImageDetailsActionsCreator).getImageDetails(imageId, showImageDetails);
            };
            _this._podsLinkClassName = "owl-pods-link";
            _this._imageLinkClassName = "owl-image-link";
            _this._imageList = [];
            _this._metadataInitialized = {
                "daemon": false,
                "statefulsets": false,
                "replicasets": false,
                "orphanpods": false
            };
            _this._store = StoreManager_1.StoreManager.GetStore(WorkloadsStore_1.WorkloadsStore);
            _this._imageDetailsStore = StoreManager_1.StoreManager.GetStore(ImageDetailsStore_1.ImageDetailsStore);
            _this._actionCreator = ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(WorkloadsActionsCreator_1.WorkloadsActionsCreator);
            _this._selectionActionCreator = ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(SelectionActionCreator_1.SelectionActionsCreator);
            _this._imageActionsCreator = ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(ImageDetailsActionsCreator_1.ImageDetailsActionsCreator);
            _this.state = { statefulSets: [], daemonSets: [], replicaSets: [], orphanPods: [] };
            _this._store.addListener(Constants_1.WorkloadsEvents.ReplicaSetsFetchedEvent, _this._onReplicaSetsFetched);
            _this._store.addListener(Constants_1.WorkloadsEvents.StatefulSetsFetchedEvent, _this._onStatefulSetsFetched);
            _this._store.addListener(Constants_1.WorkloadsEvents.DaemonSetsFetchedEvent, _this._onDaemonSetsFetched);
            _this._store.addListener(Constants_1.WorkloadsEvents.WorkloadPodsFetchedEvent, _this._onOrphanPodsFetched);
            _this._imageDetailsStore.addListener(Constants_1.ImageDetailsEvents.HasImageDetailsEvent, _this._setHasImageDetails);
            var kubeService = KubeFactory_1.KubeFactory.getKubeService();
            _this._actionCreator.getReplicaSets(kubeService);
            _this._actionCreator.getStatefulSets(kubeService);
            _this._actionCreator.getDaemonSets(kubeService);
            return _this;
        }
        OtherWorkloads.prototype.render = function () {
            var _this = this;
            var filteredSet = this._generateRenderData().filter(function (set) {
                return Utils_1.Utils.filterByName(set.name, _this.props.nameFilter);
            });
            var tableProps = {
                id: "other-workloads-table",
                showHeader: true,
                showLines: true,
                singleClickActivation: true,
                itemProvider: new Provider_1.ArrayItemProvider(filteredSet),
                ariaLabel: Resources.OtherWorkloadsText,
                columns: this._getColumns(),
                onActivate: function (event, tableRow) {
                    var eventTarget = event && event.target;
                    // make sure all links have this classname
                    if (eventTarget && !eventTarget.classList.contains(_this._podsLinkClassName) && !eventTarget.classList.contains(_this._imageLinkClassName)) {
                        _this._showWorkloadDetails(event, tableRow, filteredSet[tableRow.index]);
                    }
                }
            };
            if (filteredSet.length > 0) {
                return (React.createElement(Card_1.CustomCard, { className: "workloads-other-content k8s-card-padding flex-grow bolt-table-card bolt-card-no-vertical-padding" },
                    React.createElement(Header_1.CustomHeader, null,
                        React.createElement(Header_1.HeaderTitleArea, null,
                            React.createElement(Header_1.HeaderTitleRow, null,
                                React.createElement(Header_1.HeaderTitle, { className: "text-ellipsis", titleSize: 0 /* Medium */ }, Resources.OtherWorkloadsText)))),
                    React.createElement(Card_1.CardContent, { className: "workload-other-sets-table", contentPadding: false },
                        React.createElement(Table_1.Table, __assign({}, tableProps)))));
            }
            return null;
        };
        OtherWorkloads.prototype.componentWillUnmount = function () {
            this._imageDetailsStore.removeListener(Constants_1.ImageDetailsEvents.HasImageDetailsEvent, this._setHasImageDetails);
            this._store.removeListener(Constants_1.WorkloadsEvents.DaemonSetsFetchedEvent, this._onDaemonSetsFetched);
            this._store.removeListener(Constants_1.WorkloadsEvents.StatefulSetsFetchedEvent, this._onStatefulSetsFetched);
            this._store.removeListener(Constants_1.WorkloadsEvents.ReplicaSetsFetchedEvent, this._onReplicaSetsFetched);
            this._store.removeListener(Constants_1.WorkloadsEvents.WorkloadPodsFetchedEvent, this._onOrphanPodsFetched);
        };
        OtherWorkloads._renderSetNameCell = function (rowIndex, columnIndex, tableColumn, workload) {
            return (React.createElement(Table_1.TwoLineTableCell, { key: "col-" + columnIndex, columnIndex: columnIndex, tableColumn: tableColumn, line1: React.createElement(TooltipEx_1.Tooltip, { overflowOnly: true, text: workload.name },
                    React.createElement("span", { className: "body-m font-weight-semibold text-ellipsis" }, workload.name)), line2: React.createElement("span", { className: "body-s secondary-text text-ellipsis" }, OtherWorkloads._getSetType(workload.kind)) }));
        };
        OtherWorkloads._renderAgeCell = function (rowIndex, columnIndex, tableColumn, statefulSet) {
            var creationTime = statefulSet.creationTimeStamp ? statefulSet.creationTimeStamp : new Date();
            var itemToRender = React.createElement(Ago_1.Ago, { className: "body-m", date: new Date(creationTime) });
            return KubeCardWithTable_1.renderTableCell(rowIndex, columnIndex, tableColumn, itemToRender);
        };
        OtherWorkloads.prototype._generateRenderData = function () {
            var _this = this;
            var data = [];
            var imageId = "";
            this._showType(KubeServiceBase_1.KubeResourceType.StatefulSets) && this.state.statefulSets.forEach(function (set) {
                imageId = _this._getImageId(set.spec.template.spec, set.metadata.uid);
                if (imageId && (_this._imageList.length <= 0 || _this._imageList.findIndex(function (img) { return String_1.equals(img, imageId, true); }) < 0)) {
                    _this._imageList.push(imageId);
                }
                data.push(__assign({ name: set.metadata.name, uid: set.metadata.uid, kind: "stateful-set" /* StatefulSetKey */, creationTimeStamp: set.metadata.creationTimestamp, imageId: imageId, desiredPodCount: set.status.replicas, currentPodCount: set.status.readyReplicas, payload: set }, OtherWorkloads._getImageText(set.spec.template.spec)));
            });
            this._showType(KubeServiceBase_1.KubeResourceType.DaemonSets) && this.state.daemonSets.forEach(function (set) {
                imageId = _this._getImageId(set.spec.template.spec, set.metadata.uid);
                if (imageId && (_this._imageList.length <= 0 || _this._imageList.findIndex(function (img) { return String_1.equals(img, imageId, true); }) < 0)) {
                    _this._imageList.push(imageId);
                }
                data.push(__assign({ name: set.metadata.name, uid: set.metadata.uid, kind: "daemon-set" /* DaemonSetKey */, creationTimeStamp: set.metadata.creationTimestamp, imageId: imageId, desiredPodCount: set.status.desiredNumberScheduled, currentPodCount: set.status.numberAvailable, payload: set }, OtherWorkloads._getImageText(set.spec.template.spec)));
            });
            this._showType(KubeServiceBase_1.KubeResourceType.ReplicaSets) && this.state.replicaSets.forEach(function (set) {
                imageId = _this._getImageId(set.spec.template.spec, set.metadata.uid);
                if (imageId && (_this._imageList.length <= 0 || _this._imageList.findIndex(function (img) { return String_1.equals(img, imageId, true); }) < 0)) {
                    _this._imageList.push(imageId);
                }
                data.push(__assign({ name: set.metadata.name, uid: set.metadata.uid, kind: "replica-set" /* ReplicaSetKey */, creationTimeStamp: set.metadata.creationTimestamp, imageId: imageId, desiredPodCount: set.status.replicas, currentPodCount: set.status.readyReplicas, payload: set }, OtherWorkloads._getImageText(set.spec.template.spec)));
            });
            this._showType(KubeServiceBase_1.KubeResourceType.Pods) && this.state.orphanPods.forEach(function (pod) {
                imageId = Utils_1.Utils.getImageIdsForPods([pod])[0] || "";
                if (imageId && (_this._imageList.length <= 0 || _this._imageList.findIndex(function (img) { return String_1.equals(img, imageId, true); }) < 0)) {
                    _this._imageList.push(imageId);
                }
                var _a = Utils_1.Utils.generatePodStatusProps(pod.status), statusProps = _a.statusProps, tooltip = _a.tooltip;
                data.push(__assign({ name: pod.metadata.name, uid: pod.metadata.uid, kind: "orphan-pod" /* OrphanPodKey */, creationTimeStamp: pod.metadata.creationTimestamp, imageId: imageId, desiredPodCount: 1, currentPodCount: statusProps === Status_1.Statuses.Success ? 1 : 0, statusProps: statusProps, statusTooltip: tooltip, payload: pod }, OtherWorkloads._getImageText(pod.spec)));
            });
            return data;
        };
        OtherWorkloads.prototype._getImageId = function (podSpec, uid) {
            var podslist = StoreManager_1.StoreManager.GetStore(PodsStore_1.PodsStore).getState().podsList;
            var pods = podslist && podslist.items || [];
            return Utils_1.Utils.getImageIdForWorkload(Utils_1.Utils.getFirstContainerName(podSpec), pods, uid);
        };
        OtherWorkloads.prototype._showType = function (type) {
            return (this.props.typeFilter.length == 0 || (type != undefined && this.props.typeFilter.indexOf(type.toString()) >= 0));
        };
        OtherWorkloads._getImageText = function (spec) {
            var _a = Utils_1.Utils.getImageText(spec), imageText = _a.imageText, imageTooltipText = _a.imageTooltipText;
            return { imageDisplayText: imageText, imageTooltip: imageTooltipText };
        };
        OtherWorkloads._getSetType = function (selectedItem) {
            switch (selectedItem) {
                case "daemon-set" /* DaemonSetKey */:
                    return Resources.DaemonSetText;
                case "replica-set" /* ReplicaSetKey */:
                    return Resources.ReplicaSetText;
                case "stateful-set" /* StatefulSetKey */:
                    return Resources.StatefulSetText;
                case "orphan-pod" /* OrphanPodKey */:
                    return Resources.PodText;
            }
            return "";
        };
        return OtherWorkloads;
    }(React.Component));
    exports.OtherWorkloads = OtherWorkloads;
});
